module.exports = __webpack_public_path__ + "img/reorder.e548814f.svg";